export default __webpack_public_path__ + "static/media/user-pics-1.d0096cac.png";